import React from 'react';
import { Button, Dialogs } from '@leverege/ui-elements';
import { GroupActions } from '@leverege/molten/imagine';
import { GlobalState } from '@leverege/ui-redux';
import PositionPendingDialog from "./PositionPendingDialog.js";
import { jsx as _jsx } from "react/jsx-runtime";
const getActions = actions => {
  return new GroupActions({
    ...actions,
    queryName: 'positionPendingCounter'
  });
};
export default class PositionPendingButton extends React.Component {
  onClick = () => {
    const {
      context
    } = this.props;
    Dialogs.show({
      component: PositionPendingDialog,
      props: {
        context
      }
    });
  };
  render() {
    const {
      context
    } = this.props;
    const list = getActions(context.clientProps.actions).getList(GlobalState.get());
    const numPending = list.aggs.positionPendingAgg.count;
    const positionsWord = numPending === 1 ? 'Position' : 'Positions';
    const buttonText = `${numPending} ${positionsWord} Pending`;
    return /*#__PURE__*/_jsx(Button, {
      icon: "https://recovr-ui-assets.storage.googleapis.com/position-pending-button-icon.png",
      variant: "tertiary",
      onClick: this.onClick,
      children: buttonText
    });
  }
}